

import React, { useState, useEffect, useRef } from 'react';
import { FaSearch, FaSync, FaFileExport, FaCalendar, FaChevronDown, FaChevronUp, FaTag, FaMoneyBillWave, FaStore, FaChartLine, FaEye, FaEyeSlash } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { useLoader } from '../../../../context/LoaderProvider';

// ============================================
// STYLES
// ============================================
const styles = {
    container: {
        padding: '10px',
        maxWidth: '1600px',
        margin: '0 auto',
        fontFamily: 'Segoe UI, sans-serif'
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '16px',
        marginBottom: '10px'
    },
    statCard: {
        background: 'white',
        borderRadius: '12px',
        padding: '20px 24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        transition: 'all 0.3s ease'
    },
    statLabel: {
        fontSize: '13px',
        color: '#94a3b8',
        fontWeight: '500',
        marginBottom: '6px'
    },
    statValue: {
        fontSize: '28px',
        fontWeight: '700',
        color: '#1e293b'
    },
    statSub: {
        fontSize: '12px',
        color: '#94a3b8',
        marginTop: '4px'
    },
    filtersBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        borderRadius: '12px',
        marginBottom: '10px',
        flexWrap: 'wrap'
    },
    searchWrapper: {
        display: 'flex',
        alignItems: 'center',
        flex: '1',
        minWidth: '200px',
        background: '#f8fafc',
        borderRadius: '8px',
        padding: '0 12px',
        border: '1px solid #e2e8f0',
        transition: 'all 0.2s ease'
    },
    searchInput: {
        border: 'none',
        background: 'transparent',
        padding: '10px 8px',
        fontSize: '14px',
        outline: 'none',
        flex: '1',
        color: '#334155'
    },
    dateFilterBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 16px',
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        color: '#334155',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        minWidth: '140px',
        whiteSpace: 'nowrap'
    },
    actionBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '10px 18px',
        border: 'none',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    vendorCard: {
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        marginBottom: '12px',
        overflow: 'hidden',
        transition: 'all 0.3s ease'
    },
    vendorHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 24px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        borderBottom: '1px solid transparent'
    },
    vendorInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
    },
    vendorName: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#1e293b'
    },
    vendorId: {
        fontSize: '13px',
        color: '#94a3b8'
    },
    vendorTotal: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#e66d33'
    },
    expandedContent: {
        padding: '0 24px 24px 24px',
        background: '#fafbfc',
        borderTop: '1px solid #f0f0f0'
    },
    promotionCard: {
        background: 'white',
        borderRadius: '10px',
        marginTop: '12px',
        border: '1px solid #e8ecf0',
        overflow: 'hidden',
        transition: 'all 0.2s ease'
    },
    promotionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '14px 20px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        borderBottom: '1px solid transparent'
    },
    promotionName: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#1e293b'
    },
    promotionDetails: {
        padding: '16px 20px',
        background: '#f8fafc',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: '10px 20px',
        borderTop: '1px solid #e8ecf0'
    },
    promotionField: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px'
    },
    promotionLabel: {
        fontSize: '10px',
        color: '#94a3b8',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    promotionValue: {
        fontSize: '13px',
        fontWeight: '500',
        color: '#1e293b'
    },
    promotionCost: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#e66d33'
    },
    statusBadge: {
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: '12px',
        fontSize: '11px',
        fontWeight: '600'
    },
    statusApproved: {
        background: '#dcfce7',
        color: '#15803d'
    },
    statusPending: {
        background: '#fef9c3',
        color: '#a16207'
    },
    statusRejected: {
        background: '#fee2e2',
        color: '#b91c1c'
    },
    statusDefault: {
        background: '#f3f4f6',
        color: '#6b7280'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '20px'
    },
    modalContent: {
        background: 'white',
        borderRadius: '16px',
        padding: '32px',
        maxWidth: '480px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '10px'
    },
    modalTitle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#1e293b'
    },
    modalClose: {
        background: 'none',
        border: 'none',
        fontSize: '10px',
        cursor: 'pointer',
        color: '#94a3b8',
        padding: '4px'
    },
    modalBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    },
    dateInputGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px'
    },
    dateLabel: {
        fontSize: '13px',
        fontWeight: '500',
        color: '#475569'
    },
    dateInput: {
        padding: '10px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        outline: 'none',
        transition: 'all 0.2s ease',
        color: '#334155'
    },
    applyBtn: {
        padding: '12px',
        background: '#e66d33',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        marginTop: '8px'
    },
    dropdown: {
        position: 'absolute',
        top: 'calc(100% + 4px)',
        left: 0,
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
        minWidth: '160px',
        overflow: 'hidden',
        zIndex: 100
    },
    dropdownItem: {
        padding: '10px 18px',
        fontSize: '14px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        color: '#334155'
    },
    emptyState: {
        textAlign: 'center',
        padding: '40px 20px',
        color: '#94a3b8'
    },
    loadingOverlay: {
        textAlign: 'center',
        padding: '40px 20px',
        color: '#64748b'
    },
    expandIcon: {
        transition: 'transform 0.2s ease',
        fontSize: '14px',
        color: '#94a3b8'
    }
};

// ============================================
// API URL
// ============================================
const API_URL = "https://backend.maamaas.com/promotions/api/admin/all/campaigns";

// ============================================
// COMPONENT
// ============================================
const Promotionsaccounts = () => {
    const { showLoader, hideLoader } = useLoader();
    const [vendors, setVendors] = useState([]);
    const [filteredVendors, setFilteredVendors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedVendor, setExpandedVendor] = useState(null);
    const [expandedPromotions, setExpandedPromotions] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [dateFilter, setDateFilter] = useState('All');
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const [showCustomDateModal, setShowCustomDateModal] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [error, setError] = useState(null);
    const dateDropdownRef = useRef(null);

    // Date filter options
    const dateOptions = ['All', 'Today', 'Yesterday', 'This Week', 'This Month', 'Custom Range'];

    // ─── Fetch Campaigns ──────────────────────────────────────────
    const fetchCampaigns = async () => {
        try {
            setLoading(true);
            setError(null);
            showLoader();

            const token = localStorage.getItem("authToken");
            if (!token) {
                throw new Error("Authentication token not found");
            }

            const response = await fetch(API_URL, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch campaigns: ${response.status}`);
            }

            const data = await response.json();

            // Group campaigns by vendorId
            const vendorMap = new Map();

            data.forEach(campaign => {
                const vendorId = campaign.vendorId || 'unknown';

                if (!vendorMap.has(vendorId)) {
                    vendorMap.set(vendorId, {
                        id: `VEN-${String(vendorId).padStart(3, '0')}`,
                        vendorId: vendorId,
                        customerId: campaign.customerId || 'N/A',
                        name: `Vendor ${vendorId}`,
                        totalSpent: 0,
                        promotions: []
                    });
                }

                const vendor = vendorMap.get(vendorId);
                vendor.totalSpent += campaign.totalBudget || 0;

                vendor.promotions.push({
                    id: campaign.id,
                    campaignName: campaign.campaignName || 'Untitled Campaign',
                    approvalStatus: campaign.approvalStatus || 'PENDING',
                    description: campaign.description || '',
                    goal: campaign.goal || '',
                    medium: campaign.medium || '',
                    startDate: campaign.startDate,
                    endDate: campaign.endDate,
                    paymentStatus: campaign.paymentStatus || '',
                    campaignCode: campaign.campaignCode || '',
                    appType: campaign.appType || '',
                    totalBudget: campaign.totalBudget || 0,
                    city: campaign.city || '',
                    mediaType: campaign.mediaType || '',
                    addDisplayPosition: campaign.addDisplayPosition || '',
                    gst: campaign.gst || 0,
                    imageUrl: campaign.imageUrl || '',
                    status: campaign.status || '',
                    createdAt: campaign.createdAt,
                    customerId: campaign.customerId || 'N/A'
                });
            });

            const vendorList = Array.from(vendorMap.values());
            setVendors(vendorList);
            setFilteredVendors(vendorList);

        } catch (error) {
            console.error('❌ Error fetching campaigns:', error);
            setError(error.message || 'Failed to load campaigns');
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    useEffect(() => {
        fetchCampaigns();
    }, []);

    // ─── Filter Vendors ──────────────────────────────────────────
    useEffect(() => {
        let filtered = [...vendors];

        // Search filter - by vendorId OR customerId
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            filtered = filtered.filter(vendor =>
                // Search by vendor ID
                vendor.id.toLowerCase().includes(query) ||
                vendor.vendorId.toString().includes(query) ||
                // Search by customer ID
                vendor.customerId.toLowerCase().includes(query) ||
                // Search by vendor name
                vendor.name.toLowerCase().includes(query) ||
                // Search in promotions
                vendor.promotions.some(p =>
                    p.campaignName.toLowerCase().includes(query) ||
                    p.campaignCode.toLowerCase().includes(query) ||
                    p.customerId.toLowerCase().includes(query)
                )
            );
        }

        // Date filter
        if (dateFilter !== 'All' && dateFilter !== 'Custom Range') {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            filtered = filtered.filter(vendor => {
                return vendor.promotions.some(promo => {
                    const promoDate = new Date(promo.startDate);
                    promoDate.setHours(0, 0, 0, 0);

                    switch (dateFilter) {
                        case 'Today':
                            return promoDate.getTime() === today.getTime();
                        case 'Yesterday':
                            const yesterday = new Date(today);
                            yesterday.setDate(yesterday.getDate() - 1);
                            return promoDate.getTime() === yesterday.getTime();
                        case 'This Week':
                            const weekStart = new Date(today);
                            weekStart.setDate(today.getDate() - today.getDay());
                            return promoDate >= weekStart;
                        case 'This Month':
                            return promoDate.getMonth() === today.getMonth() &&
                                promoDate.getFullYear() === today.getFullYear();
                        default:
                            return true;
                    }
                });
            });
        } else if (dateFilter === 'Custom Range' && fromDate && toDate) {
            const from = new Date(fromDate);
            const to = new Date(toDate);
            from.setHours(0, 0, 0, 0);
            to.setHours(23, 59, 59, 999);

            filtered = filtered.filter(vendor => {
                return vendor.promotions.some(promo => {
                    const promoDate = new Date(promo.startDate);
                    return promoDate >= from && promoDate <= to;
                });
            });
        }

        setFilteredVendors(filtered);
    }, [searchQuery, dateFilter, fromDate, toDate, vendors]);

    // ─── Calculate Stats ─────────────────────────────────────────
    const totalVendors = filteredVendors.length;
    const totalSpent = filteredVendors.reduce((sum, v) => sum + v.totalSpent, 0);
    const totalPromotions = filteredVendors.reduce((sum, v) => sum + v.promotions.length, 0);
    const avgSpent = totalVendors > 0 ? totalSpent / totalVendors : 0;

    // ─── Toggle Expand Vendor ────────────────────────────────────
    const toggleVendor = (vendorId) => {
        setExpandedVendor(expandedVendor === vendorId ? null : vendorId);
    };

    // ─── Toggle Expand Promotion (Independent) ───────────────────
    const togglePromotion = (promoId) => {
        setExpandedPromotions(prev => ({
            ...prev,
            [promoId]: !prev[promoId]
        }));
    };

    // ─── Handle Date Filter Select ──────────────────────────────
    const handleDateSelect = (option) => {
        if (option === 'Custom Range') {
            setShowCustomDateModal(true);
            setShowDateDropdown(false);
        } else {
            setDateFilter(option);
            setShowDateDropdown(false);
        }
    };

    // ─── Apply Custom Range ──────────────────────────────────────
    const applyCustomRange = () => {
        if (fromDate && toDate) {
            setDateFilter('Custom Range');
            setShowCustomDateModal(false);
        }
    };

    // ─── Format Currency ─────────────────────────────────────────
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    };

    // ─── Format Date ─────────────────────────────────────────────
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    // ─── Get Status Badge ────────────────────────────────────────
    const getStatusBadge = (status) => {
        const statusMap = {
            'APPROVED': { class: styles.statusApproved, label: 'Approved' },
            'PENDING': { class: styles.statusPending, label: 'Pending' },
            'REJECTED': { class: styles.statusRejected, label: 'Rejected' },
            'DRAFT': { class: styles.statusDefault, label: 'Draft' }
        };
        return statusMap[status?.toUpperCase()] || { class: styles.statusDefault, label: status || 'Unknown' };
    };

    // ─── Get Date Filter Display Text ───────────────────────────
    const getDateFilterDisplay = () => {
        if (dateFilter === 'Custom Range' && fromDate && toDate) {
            return `${fromDate} to ${toDate}`;
        }
        return dateFilter;
    };

    // ─── Refresh ──────────────────────────────────────────────────
    const handleRefresh = () => {
        fetchCampaigns();
    };

    // ─── Export ──────────────────────────────────────────────────
    const handleExport = () => {
        if (filteredVendors.length === 0) {
            alert('No data to export.');
            return;
        }
        // TODO: Implement export
        alert('Export functionality coming soon!');
    };

    // ─── Render ──────────────────────────────────────────────────
    if (loading) {
        return (
            <div style={styles.container}>
                <div style={styles.loadingOverlay}>
                    <div className="spinner" style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #f3f4f6',
                        borderTop: '4px solid #e66d33',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 12px'
                    }}></div>
                    <p>Loading campaigns...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={styles.container}>
                <div style={styles.emptyState}>
                    <p style={{ color: '#dc2626', fontWeight: '600' }}>⚠️ {error}</p>
                    <button
                        onClick={handleRefresh}
                        style={{
                            ...styles.actionBtn,
                            background: '#e66d33',
                            color: 'white',
                            marginTop: '12px'
                        }}
                    >
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            {/* ─── Dashboard Stats ────────────────────────────────── */}
            <div style={styles.statsGrid}>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Vendors</div>
                    <div style={styles.statValue}>{totalVendors}</div>
                    <div style={styles.statSub}>Vendors with promotions</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Spent</div>
                    <div style={styles.statValue}>{formatCurrency(totalSpent)}</div>
                    <div style={styles.statSub}>Across all promotions</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Promotions</div>
                    <div style={styles.statValue}>{totalPromotions}</div>
                    <div style={styles.statSub}>Total campaigns bought</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Average Spend</div>
                    <div style={styles.statValue}>
                        {totalVendors > 0 ? formatCurrency(avgSpent) : '₹0.00'}
                    </div>
                    <div style={styles.statSub}>Per vendor average</div>
                </div>
            </div>

            {/* ─── Filters Bar ────────────────────────────────────── */}
            <div style={styles.filtersBar}>
                {/* Search */}
                <div style={styles.searchWrapper}>
                    <FaSearch color="#94a3b8" size={16} />
                    <input
                        type="text"
                        style={styles.searchInput}
                        placeholder="Search by Vendor ID, Customer ID or Campaign..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    {searchQuery && (
                        <span
                            style={{ cursor: 'pointer', color: '#94a3b8' }}
                            onClick={() => setSearchQuery('')}
                        >
                            ✕
                        </span>
                    )}
                </div>

                {/* Date Filter */}
                <div style={{ position: 'relative' }} ref={dateDropdownRef}>
                    <button
                        style={styles.dateFilterBtn}
                        onClick={() => setShowDateDropdown(!showDateDropdown)}
                    >
                        <FaCalendar color="#e66d33" />
                        <span>{getDateFilterDisplay()}</span>
                        <FaChevronDown size={12} color="#94a3b8" />
                    </button>

                    {showDateDropdown && (
                        <div style={styles.dropdown}>
                            {dateOptions.map(option => (
                                <div
                                    key={option}
                                    style={{
                                        ...styles.dropdownItem,
                                        background: dateFilter === option ? '#fef3e8' : 'white',
                                        color: dateFilter === option ? '#e66d33' : '#334155'
                                    }}
                                    onClick={() => handleDateSelect(option)}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Action Buttons */}
                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#f1f5f9',
                        color: '#475569'
                    }}
                    onClick={() => {
                        setSearchQuery('');
                        setDateFilter('All');
                        setFromDate('');
                        setToDate('');
                    }}
                >
                    <FaSync size={14} /> Clear
                </button>

                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#e66d33',
                        color: 'white'
                    }}
                    onClick={handleRefresh}
                >
                    <FaSync size={14} /> Refresh
                </button>

                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#16a34a',
                        color: 'white'
                    }}
                    onClick={handleExport}
                >
                    <FaFileExport size={14} /> Export
                </button>
            </div>

            {/* ─── Vendor List ────────────────────────────────────── */}
            {filteredVendors.length === 0 ? (
                <div style={styles.emptyState}>
                    <p>No vendors found matching the current filters.</p>
                </div>
            ) : (
                filteredVendors.map((vendor) => {
                    // Check if any promotion in this vendor is expanded
                    const hasExpandedPromotion = vendor.promotions.some(p => expandedPromotions[p.id]);

                    return (
                        <div key={vendor.id} style={styles.vendorCard}>
                            {/* Vendor Header */}
                            <div
                                style={{
                                    ...styles.vendorHeader,
                                    borderBottom: expandedVendor === vendor.id ? '1px solid #f0f0f0' : '1px solid transparent',
                                    background: expandedVendor === vendor.id ? '#fafbfc' : 'white'
                                }}
                                onClick={() => toggleVendor(vendor.id)}
                            >
                                <div style={styles.vendorInfo}>
                                    <div>
                                        <div style={styles.vendorName}>{vendor.name}</div>
                                        <div style={styles.vendorId}>
                                            Vendor ID: {vendor.id}
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '2px' }}>
                                            {vendor.promotions.length} promotions
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                    <div style={{ textAlign: 'right' }}>
                                        <div style={styles.vendorTotal}>{formatCurrency(vendor.totalSpent)}</div>
                                        <div style={{ fontSize: '12px', color: '#94a3b8' }}>Total Spent</div>
                                    </div>
                                    {expandedVendor === vendor.id ? (
                                        <FaChevronUp color="#94a3b8" />
                                    ) : (
                                        <FaChevronDown color="#94a3b8" />
                                    )}
                                </div>
                            </div>

                            {/* Expanded Vendor Content - Shows Promotions */}
                            {expandedVendor === vendor.id && (
                                <div style={styles.expandedContent}>
                                    <div style={{
                                        padding: '16px 0 8px 0',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        color: '#1e293b',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <FaTag size={16} color="#e66d33" />
                                        Promotions Purchased
                                        <span style={{
                                            fontSize: '13px',
                                            fontWeight: '400',
                                            color: '#94a3b8',
                                            marginLeft: '4px'
                                        }}>
                                            ({vendor.promotions.length} promotions)
                                        </span>
                                    </div>

                                    {vendor.promotions.length === 0 ? (
                                        <div style={styles.emptyState}>
                                            <p>No promotions purchased</p>
                                        </div>
                                    ) : (
                                        <>
                                            {/* Promotion Cards - Each is independently expandable */}
                                            {vendor.promotions.map((promo, index) => {
                                                const isExpanded = expandedPromotions[promo.id] || false;
                                                const statusBadge = getStatusBadge(promo.approvalStatus);

                                                return (
                                                    <div key={promo.id || index} style={styles.promotionCard}>
                                                        {/* Promotion Header - Click to expand/collapse independently */}
                                                        <div
                                                            style={{
                                                                ...styles.promotionHeader,
                                                                borderBottom: isExpanded ? '1px solid #e8ecf0' : '1px solid transparent',
                                                                background: isExpanded ? '#f8fafc' : 'white'
                                                            }}
                                                            onClick={() => togglePromotion(promo.id)}
                                                        >
                                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                                <div style={styles.promotionName}>{promo.campaignName}</div>
                                                                <div style={{ fontSize: '12px', color: '#94a3b8' }}>
                                                                    {promo.campaignCode}
                                                                </div>
                                                            </div>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                                                <div style={{ textAlign: 'right' }}>
                                                                    <div style={styles.promotionCost}>{formatCurrency(promo.totalBudget)}</div>
                                                                    <div style={{ fontSize: '11px', color: '#94a3b8' }}>Budget</div>
                                                                </div>
                                                                <span style={{ ...styles.statusBadge, ...statusBadge.class }}>
                                                                    {statusBadge.label}
                                                                </span>
                                                                {isExpanded ? (
                                                                    <FaChevronUp style={styles.expandIcon} />
                                                                ) : (
                                                                    <FaChevronDown style={styles.expandIcon} />
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Promotion Details - Only shown when this specific promotion is expanded */}
                                                        {isExpanded && (
                                                            <div style={styles.promotionDetails}>
                                                                <div style={styles.promotionField}>
                                                                    <span style={styles.promotionLabel}>Goal</span>
                                                                    <span style={styles.promotionValue}>{promo.goal || 'N/A'}</span>
                                                                </div>
                                                                <div style={styles.promotionField}>
                                                                    <span style={styles.promotionLabel}>Medium</span>
                                                                    <span style={styles.promotionValue}>{promo.medium || 'N/A'}</span>
                                                                </div>
                                                                <div style={styles.promotionField}>
                                                                    <span style={styles.promotionLabel}>App Type</span>
                                                                    <span style={styles.promotionValue}>{promo.appType || 'N/A'}</span>
                                                                </div>

                                                                <div style={styles.promotionField}>
                                                                    <span style={styles.promotionLabel}>Start Date</span>
                                                                    <span style={styles.promotionValue}>{formatDate(promo.startDate)}</span>
                                                                </div>
                                                                <div style={styles.promotionField}>
                                                                    <span style={styles.promotionLabel}>End Date</span>
                                                                    <span style={styles.promotionValue}>{formatDate(promo.endDate)}</span>
                                                                </div>
                                                                <div style={styles.promotionField}>
                                                                    <span style={styles.promotionLabel}>Payment Status</span>
                                                                    <span style={styles.promotionValue}>{promo.paymentStatus || 'N/A'}</span>
                                                                </div>

                                                                <div style={styles.promotionField}>
                                                                    <span style={styles.promotionLabel}>Media Type</span>
                                                                    <span style={styles.promotionValue}>{promo.mediaType || 'N/A'}</span>
                                                                </div>
                                                                <div style={styles.promotionField}>
                                                                    <span style={styles.promotionLabel}>Display Position</span>
                                                                    <span style={styles.promotionValue}>{promo.addDisplayPosition || 'N/A'}</span>
                                                                </div>
                                                                <div style={styles.promotionField}>
                                                                    <span style={styles.promotionLabel}>City</span>
                                                                    <span style={styles.promotionValue}>{promo.city || 'N/A'}</span>
                                                                </div>

                                                                <div style={styles.promotionField}>
                                                                    <span style={styles.promotionLabel}>GST</span>
                                                                    <span style={styles.promotionValue}>{formatCurrency(promo.gst)}</span>
                                                                </div>
                                                                <div style={styles.promotionField}>
                                                                    <span style={styles.promotionLabel}>Status</span>
                                                                    <span style={styles.promotionValue}>{promo.status || 'N/A'}</span>
                                                                </div>
                                                                <div style={styles.promotionField}>
                                                                    <span style={styles.promotionLabel}>Customer ID</span>
                                                                    <span style={styles.promotionValue}>{promo.customerId}</span>
                                                                </div>

                                                                {promo.description && (
                                                                    <div style={{ ...styles.promotionField, gridColumn: '1 / -1' }}>
                                                                        <span style={styles.promotionLabel}>Description</span>
                                                                        <span style={styles.promotionValue}>{promo.description}</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}

                                            {/* Total Row */}
                                            <div style={{
                                                background: '#f8fafc',
                                                borderRadius: '10px',
                                                padding: '16px 20px',
                                                marginTop: '16px',
                                                border: '2px solid #e66d33',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}>
                                                <div style={styles.promotionName}>
                                                    <FaMoneyBillWave color="#e66d33" style={{ marginRight: '8px' }} />
                                                    Total Spent on Promotions
                                                </div>
                                                <div style={{
                                                    fontSize: '18px',
                                                    fontWeight: '700',
                                                    color: '#e66d33'
                                                }}>
                                                    {formatCurrency(vendor.totalSpent)}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })
            )}

            {/* ─── Custom Range Modal ─────────────────────────────── */}
            {showCustomDateModal && (
                <div style={styles.modalOverlay} onClick={() => setShowCustomDateModal(false)}>
                    <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>Select Date Range</h3>
                            <button style={styles.modalClose} onClick={() => setShowCustomDateModal(false)}>
                                <MdClose />
                            </button>
                        </div>

                        <div style={styles.modalBody}>
                            <div style={styles.dateInputGroup}>
                                <label style={styles.dateLabel}>From Date</label>
                                <input
                                    type="date"
                                    style={styles.dateInput}
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    max={toDate || undefined}
                                />
                            </div>

                            <div style={styles.dateInputGroup}>
                                <label style={styles.dateLabel}>To Date</label>
                                <input
                                    type="date"
                                    style={styles.dateInput}
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    min={fromDate || undefined}
                                />
                            </div>

                            <button
                                style={styles.applyBtn}
                                onClick={applyCustomRange}
                                disabled={!fromDate || !toDate}
                            >
                                Apply Range
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ─── Spinner Animation ────────────────────────────────── */}
            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default Promotionsaccounts;